(() => {
  const dialog = document.querySelector('[data-installments-dialog]');
  if (!dialog) return;

  const locale = document.documentElement.lang === 'ar' ? 'ar-AE' : 'en-AE';
  const amountNodes = [...dialog.querySelectorAll('[data-installments-schedule-amount]')];
  const terms = dialog.querySelector('[data-installments-terms]');
  let currentOffer = null;
  let previousFocus = null;

  function formatMoney(minor, currency, whole = false) {
    const value = whole ? Math.round(minor / 100) : minor / 100;
    const number = new Intl.NumberFormat(locale, {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2,
    }).format(value);
    const currencyLabel = currency === 'AED'
      ? document.documentElement.dataset.currencyAedLabel || currency
      : currency;
    return `${number} ${currencyLabel}`;
  }

  function updateOffer(offer, minor) {
    if (!offer || !Number.isFinite(minor) || minor <= 0) return;
    offer.dataset.installmentsAmountMinor = String(minor);
    const label = offer.querySelector('[data-installments-offer-amount]');
    if (label) label.textContent = formatMoney(minor / 4, offer.dataset.installmentsCurrency || 'AED', true);
    if (dialog.open && offer === currentOffer) renderPlan();
  }

  function syncCartOffers(root = document) {
    root.querySelectorAll?.('[data-cart-page]').forEach((page) => {
      const form = page.querySelector('[data-cart-form]');
      if (!form || !form.hasAttribute('data-cart-paid-total-minor')) return;
      const paid = Number(form.dataset.cartPaidTotalMinor);
      const points = Number(form.dataset.cartLoyaltyAppliedPoints || 0);
      page.querySelectorAll('[data-installments-offer]').forEach((offer) => {
        updateOffer(offer, Math.max(0, paid - points * 100));
      });
    });
  }

  syncCartOffers();

  function renderPlan() {
    if (!currentOffer) return;
    const totalMinor = Math.max(0, Number.parseInt(currentOffer.dataset.installmentsAmountMinor || '0', 10));
    const currency = currentOffer.dataset.installmentsCurrency || 'AED';
    const base = Math.floor(totalMinor / 4);
    const extra = totalMinor % 4;
    dialog.querySelector('[data-installments-total]').textContent = formatMoney(totalMinor, currency);
    amountNodes.forEach((node, index) => {
      node.textContent = formatMoney(base + (index < extra ? 1 : 0), currency);
    });
  }

  function updateTerms() {
    const selected = dialog.querySelector('[data-installments-provider]:checked');
    const url = selected?.dataset.installmentsTermsUrl || '';
    terms.hidden = !url;
    if (url) terms.href = url;
    else terms.removeAttribute('href');
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-installments-open]');
    if (!trigger) return;
    const offer = trigger.closest('[data-installments-offer]');
    if (!offer) return;
    if (offer.classList.contains('le-installments-offer--cart')) syncCartOffers();
    currentOffer = offer;
    previousFocus = trigger;
    renderPlan();
    updateTerms();
    dialog.showModal();
  });

  dialog.addEventListener('click', (event) => {
    if (event.target.closest('[data-installments-close]') || event.target === dialog) dialog.close();
  });
  dialog.addEventListener('change', (event) => {
    if (event.target.matches('[data-installments-provider]')) updateTerms();
  });
  dialog.addEventListener('close', () => {
    if (previousFocus?.isConnected) previousFocus.focus();
    previousFocus = null;
    currentOffer = null;
  });

  document.addEventListener('letoile:installments:amount', (event) => {
    const scope = event.detail?.scope || event.target;
    const amountMinor = Number(event.detail?.amountMinor);
    scope.querySelectorAll?.('[data-installments-offer]').forEach((offer) => updateOffer(offer, amountMinor));
  });
})();
